<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center class="heading">{{year}} Editie</center>
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <div class="embed-responsive embed-responsive-16by9">
                                <iframe
                                  v-if="info.stream"
                                  class="embed-responsive-item"
                                  v-bind:src="'https://www.youtube.com/embed/'+info.stream"
                                  frameborder="0"
                                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                  allowfullscreen></iframe>
                              </div><br>
                              <div class="row">
                                <div class="col-lg-6">
                                  <p v-html="info.message"></p>
                                </div>
                                <div class="col-lg-6">
                                  <img v-bind:src="info.image" width="100%" />
                                </div>
                              </div>
                              <base-button tag="a" v-bind:href="'/programma/' + year" type="primary" class="mt-4">
                                  Programma {{year}}
                              </base-button>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>

      <section class="section section-lg pt-lg-0">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <h1>Talk's</h1>
                              <ul class="list-group list-group-flush">
                                <a
                                  type="button"
                                  v-for="talk in talks"
                                  v-if="talk.talk"
                                  v-bind:href="'/talk/' + year + '/' + talks.indexOf(talk)"
                                  class="list-group-item list-group-item-action">
                                    {{talk.title}}
                                    <span class="pull-right"><i>{{talk.speaker}}</i></span>
                                </a>
                              </ul>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>

  </div>
</template>

<script>
import ArchiefData from "@/data/ArchiefData.js";
import ProgrammaData from "@/data/ProgrammaData.js";
import variables from "../variables.js";

export default {
  data(){
    return {
      info: {},
      year: 0,
      talks: []
    }
  },
  mounted(){
    if (this.$route.params.year){
      this.year = this.$route.params.year;
    } else {
      this.year = variables.getVariable("event");
    }
    ArchiefData.load(this.year).then(response => {
      console.log(response);
      this.info = response.data;
    });
    ProgrammaData.load(this.year).then(response => {
      this.talks = response.data;
    });
  }
}
</script>
